module.exports = __webpack_public_path__ + "static/media/small.46f32d58.svg";